import { create } from 'zustand'
import { _getGroup, _setGroupBackground } from '../data/groups';
import { _getGroupIcon } from '../helpers/groupIcons';
import { useAuthStore } from './useAuthStore';

export const useCurrentGroupStore = create((set, get) => ({
    groupId: "",
    group: {},
    groupIcon: "",
    isLoading: false,
    lastFetched: null,
    cacheExpiration: 10 * 60 * 1000, // 10 minutes in milliseconds

    clear: () => set({
        groupId: "",
        group: {},
        groupIcon: "",
        isLoading: false,
        lastFetched: null,
    }),

    setGroup: (groupData) => set({
        group: groupData,
        lastFetched: Date.now(),
        isLoading: false
    }),

    setGroupId: (groupId) => set({
        groupId: groupId
    }),

    setGroupName: (newGroupName) => set((state) => ({
        group: {
            ...state.group,
            groupName: newGroupName
        }
    })),

    setGroupIcon: async (newGroupIcon) => {
        var newIconUrl = await _getGroupIcon(newGroupIcon ?? "meeple_orange");
        set({
            groupIcon: newIconUrl
        })
    },

    setGroupBackground: async (newGroupBackground) => set((state) => ({
         group : {
            ...state.group,
            headerImage: newGroupBackground
        }
    })),

    fetchGroup: async (fetchGroupId, force = false) => {
        if (!useAuthStore.getState().isAuthenticated) return;

        const { groupId, group, isLoading, lastFetched, cacheExpiration } = get();

        if (isLoading) return group;

        const isCacheExpired = !lastFetched || Date.now() - lastFetched > cacheExpiration;
        if (fetchGroupId === groupId && !isCacheExpired && !force) return group;

        try {
            set({ isLoading: true });
            const fetchedGroup = await _getGroup(fetchGroupId);
            const groupIconUrl = await _getGroupIcon(fetchedGroup.icon ?? "meeple_orange");
            if (!fetchedGroup.headerImage) {
                fetchedGroup.headerImage = "background1";
            }
            
            set({
                group: fetchedGroup,
                groupIcon: groupIconUrl,
                groupId: fetchGroupId,
                lastFetched: Date.now(),
                isLoading: false
            });

            return fetchedGroup;
        } catch (error) {
            set({ isLoading: false });
            throw error;
        }

    }

}));
